import React, { useState, useEffect, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { updateCaseFolder } from '../../../../../services/api';
import ThemeContext from '../../../../../ThemeContext';

const RenameFolderModal = ({ show, onHide, folder, onSuccess }) => {
  const { theme } = useContext(ThemeContext);
  const [folderName, setFolderName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (folder) {
      setFolderName(folder.name);
    }
  }, [folder]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!folderName.trim()) {
      toast.warning('Please enter a folder name', {
        style: {
          backgroundColor: theme.colors.bgPrimary,
          border: `1px solid ${theme.colors.borderColor}`,
          color: theme.colors.warning,
        },
      });
      return;
    }

    try {
      setIsLoading(true);
      await updateCaseFolder(folder.id, { name: folderName });
      toast.success('Folder renamed successfully', {
        style: {
          backgroundColor: theme.colors.bgPrimary,
          border: `1px solid ${theme.colors.borderColor}`,
          color: theme.colors.success,
        },
      });
      onSuccess();
      onHide();
    } catch (error) {
      toast.error(`Failed to rename folder: ${error.response?.data?.message || error.message}`, {
        style: {
          backgroundColor: theme.colors.bgPrimary,
          border: `1px solid ${theme.colors.borderColor}`,
          color: theme.colors.danger,
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header
        style={{
          backgroundColor: theme.colors.primary,
          color: theme.colors.textWhite,
          borderBottom: 'none',
        }}
      >
        <Modal.Title style={{ fontSize: 'clamp(12px, 2.5vw, 14px)' }}>Rename Folder</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          backgroundColor: theme.colors.bgPrimary,
          color: theme.colors.textPrimary,
        }}
      >
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label
              htmlFor="folderName"
              style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontSize: 'clamp(9px, 2vw, 10px)',
                fontWeight: 'bold',
              }}
            >
              Folder Name
            </label>
            <input
              type="text"
              id="folderName"
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              placeholder="Enter folder name"
              style={{
                width: '100%',
                padding: 'clamp(6px, 2vw, 8px)',
                fontSize: 'clamp(9px, 2vw, 10px)',
                border: `1px solid ${theme.colors.borderColor}`,
                borderRadius: '5px',
                backgroundColor: theme.colors.bgSecondary,
                color: theme.colors.textPrimary,
              }}
              disabled={isLoading}
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer
        style={{
          backgroundColor: theme.colors.bgPrimary,
          borderTop: `1px solid ${theme.colors.borderColor}`,
        }}
      >
        <button
          onClick={onHide}
          disabled={isLoading}
          style={{
            padding: 'clamp(6px, 2vw, 8px) clamp(12px, 3vw, 16px)',
            fontSize: 'clamp(9px, 2vw, 10px)',
            border: 'none',
            borderRadius: '5px',
            backgroundColor: theme.colors.danger,
            color: theme.colors.textWhite,
            cursor: isLoading ? 'not-allowed' : 'pointer',
            opacity: isLoading ? 0.6 : 1,
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          disabled={isLoading}
          style={{
            padding: 'clamp(6px, 2vw, 8px) clamp(12px, 3vw, 16px)',
            fontSize: 'clamp(9px, 2vw, 10px)',
            border: 'none',
            borderRadius: '5px',
            background: theme.gradients.primary,
            color: theme.colors.textWhite,
            cursor: isLoading ? 'not-allowed' : 'pointer',
            opacity: isLoading ? 0.6 : 1,
          }}
        >
          {isLoading ? 'Saving...' : 'Save'}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default RenameFolderModal;